export default "__VITE_ASSET__f0eb2d39__"